import { useSelector } from 'react-redux';

import { isBillingPlanIdUsageBilledHighVolume } from '../../enums/billing-plan-ids';
import { NonWalletedPlanProfileId } from '../../enums/plan-profiles';
import Global from '../../store/global-selectors';

/**
 * Is the seller on a HighVolume usage based billing plan
 * @deprecated
 * @returns {boolean}
 */
export const useIsSellerOnNonWalletHighVolumeUsageBasedBillingPlan = () => {
  const { planProfileId, billingPlanId } = useSelector(Global.selectSellerSubscriptionPlanInfo) ?? {};

  if (parseInt(planProfileId, 10) !== NonWalletedPlanProfileId) {
    return false;
  }

  return isBillingPlanIdUsageBilledHighVolume(billingPlanId);
};
